export default __webpack_public_path__ + "static/media/what-we-offers-02.62a820c3.jpg";